export default "__VITE_ASSET__WzhiFgHJ__"